<template>

  <t-page>

    <t-page-form :title="'Formulário de '+title" tabs :command="onCommand" @onSubmit="onSubmit">

      <t-input v-model="form.quoteId" hidden/>

      <t-form-tab title="Dados Básicos">

        <t-form-card title="Dados da Nfe" icon-card-heading>

          <b-row>

            <t-input cols="4" v-model="form.companyId" label="Empresa"
                                :options="clientOptions" select required
            />

            <t-input cols="4" v-model="form.companyId" label="Regime" fixed/>

            <t-input cols="4" v-model="form.expiration" label="Status" fixed/>

          </b-row>

          <b-row>

            <t-input cols="2" v-model="form.quoteNumber" label="Nota Fiscal" fixed-except-insert/>

            <t-input cols="1" v-model="form.quoteNumber" label="Mod."/>

            <t-input cols="2" v-model="form.quoteNumber" label="Série"/>

            <t-input cols="3" v-model="form.quoteNumber" label="Natureza"/>

            <t-input cols="2" v-model="form.expiration" label="Emissão" date date-now required/>

            <t-input cols="2" v-model="form.expiration" label="Saída" date required/>

          </b-row>

          <b-row>

            <t-input cols="6" v-model="form.companyId" label="Chave de Acesso" fixed/>

            <t-input cols="3" v-model="form.companyId" label="Protocolo" fixed/>

            <t-input cols="3" v-model="form.expiration" label="Data do Recibo" fixed/>

          </b-row>

        </t-form-card>

        <t-form-card title="Destinatário" icon-building>

          <b-row>

            <t-input cols="6" v-model="form.customerId" label="Cliente"
                                :options="clientOptions" fixed>

              <template #input-group-append>

                <t-button title="Detalhar Cliente" icon-list/>


              </template>

            </t-input>

            <t-input cols="6" v-model="form.customerId" label="CNPJ"
                                fixed/>

          </b-row>
        </t-form-card>

        <t-form-card title="Transporte" icon-truck>
          <b-row>

            <t-input cols="4" v-model="form.paymentMethodId" label="Transportadora"
                                :options="clientOptions" select required
            />

            <t-input cols="4" v-model="form.paymentPlanId" label="Tipo de Frete"
                                :options="clientOptions" select required
            />

            <t-input cols="4" v-model="form.shippingCost" label="Valor do Frete" money>
              <template #default>
                <b-form-checkbox :disabled="form.shippingCost == 0" v-model="form.shippingIsAdd" switch>
                  <small>Acrescentar no valor total</small>
                </b-form-checkbox>
              </template>
            </t-input>

          </b-row>

          <b-row>
            <t-input cols="2" v-model="form.paymentPlanId" label="Quantidade" fixed/>
            <t-input cols="2" v-model="form.paymentPlanId" label="Espécie" fixed/>
            <t-input cols="2" v-model="form.paymentPlanId" label="Marca" fixed/>
            <t-input cols="2" v-model="form.paymentPlanId" label="Peso Bruto" fixed/>
            <t-input cols="2" v-model="form.paymentPlanId" label="Peso Liquído" fixed/>
            <t-input cols="2" v-model="form.paymentPlanId" label="Placa" fixed>
              <template #default>
                <b-link class="small text-secondary">
                  <b-icon-plus></b-icon-plus>
                  Detalhar Frete
                </b-link>
              </template>
            </t-input>
          </b-row>
        </t-form-card>


        <t-form-card title="Valores Totais" icon-cash-stack>

          <b-row>
            <t-input cols="2" v-model="form.paymentPlanId" label="Total IPI" fixed/>
            <t-input cols="2" v-model="form.paymentPlanId" label="Total ICMS" fixed/>
            <t-input cols="2" v-model="form.paymentPlanId" label="Total Frete" fixed/>
            <t-input cols="3" v-model="form.paymentPlanId" label="Total Produtos" fixed highlight/>
            <t-input cols="3" v-model="form.paymentPlanId" label="Total Nota Fiscal" fixed highlight />

          </b-row>

          <b-row>
            <t-input cols="2" v-model="form.paymentPlanId" label="Total PIS" fixed/>
            <t-input cols="2" v-model="form.paymentPlanId" label="Total Cofins" fixed/>
            <t-input cols="2" v-model="form.paymentPlanId" label="Desp. Acessórias" fixed/>
            <t-input cols="2" v-model="form.paymentPlanId" label="Base de Cálculo" fixed/>
            <t-input cols="2" v-model="form.paymentPlanId" label="BC do ICMS ST" fixed/>
            <t-input cols="2" v-model="form.paymentPlanId" label="Total do ICMS ST" fixed>
              <template #default>
                <b-link class="small text-secondary">
                  <b-icon-plus></b-icon-plus>
                  Detalhar Totais
                </b-link>
              </template>
            </t-input>
          </b-row>
        </t-form-card>

        <t-form-card title="Observações" icon-chat-right-text>
          <t-input v-model="form.note" label="Observações" max-length="500" textarea required/>
          <t-input v-model="form.note" label="Informações Complementares" small="Informações inseridas automaticamente para validação da NFe" fixed />
        </t-form-card>
      </t-form-tab>

      <t-form-tab title="Produtos" hash="product">
        Teste
      </t-form-tab>
      <t-form-tab title="Impostos" hash="tax">
        Teste
      </t-form-tab>
      <t-form-tab title="Financeiro"  hash="financial">
        Teste
      </t-form-tab>
      <t-form-tab title="Eventos"  hash="event">
        <br/>
        Informações sobre data de cadastro, modificação, envio ao Sefaz, cartas de correção, entre outras ações
      </t-form-tab>

      <template #footer>

        <t-button text="Incluir Nota Fiscal" submit primary/>

        <!-- Após NF-e validada -->
        <t-button :disabled="onSending" text="Transmitir NF-e"/>


        <!-- Após NF-e validada -->
        <t-dropdown :disabled="onSending" variant="outline-primary">
          <template #button-content>
            NF-e Ações
          </template>
          <b-dropdown-item-button>Reenviar E-mail</b-dropdown-item-button>
          <b-dropdown-item-button>Imprimir NF-e</b-dropdown-item-button>
          <b-dropdown-item-button>Download XML</b-dropdown-item-button>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item-button variant="danger">Cancelar NF-e</b-dropdown-item-button>
        </t-dropdown>

        <!-- Enquanto estiver em modo alteração -->
        <t-button :disabled="onSending" text="Importar Pedido"/>


      </template>

    </t-page-form>


  </t-page>

</template>
<script>
//
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"

//pageFormMixin.setServiceCRUD(crud);

export default {
  mixins: [pageDefaultMixin, pageFormMixin],
  data() {
    return {
      title: "Nota Fiscal",
      form: {
        quoteId: 456987987,
        quoteNumber: 0,
        companyId: 0,
        customerId: 0,
        sellerId: 0,
        paymentMethodId: 0,
        paymentPlanId: 0,
        customerRegistered: true,
        customerNotRegisteredName: "",
        customerNotRegisteredContact: "",
        customerNotRegisteredTel: "",
        customerNotRegisteredEmail: "",
        expiration: "",
        shippingCost: 0,
        shippingIsAdd: false,
        note: "",
        status: 0,

      },
      clientOptions: [{value: 1, text: "Teste"}, {value: 2, text: "Teste 2"}, {value: 3, text: "Teste 3"}]
    }
  },
  computed: {},
  methods: {


    onSubmit() {

      /*
     * Validações específicas, após validação básica padrão */

      console.log('Form enviado' + JSON.stringify(this.form))

      //Depois quando estiver enviando será controlado aqui por fora o envio
      this.command = "sending"

    },

  },
  mounted() {


  }

}
</script>
